import { useEffect, useState } from 'react'

interface SplashScreenProps {
  onComplete: () => void
}

export default function SplashScreen({ onComplete }: SplashScreenProps) {
  const [isVisible, setIsVisible] = useState(true)

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false)
      // Give a bit more time for the fade out animation to complete
      setTimeout(() => {
        onComplete()
      }, 300)
    }, 1200) // Show for 1.2 seconds

    return () => clearTimeout(timer)
  }, [onComplete])

  return (
    <div
      className={`fixed inset-0 z-50 flex items-center justify-center bg-white dark:bg-tech-900 transition-opacity duration-300 ${
        isVisible ? 'opacity-100' : 'opacity-0'
      }`}
    >
      <div className="flex flex-col items-center space-y-6">
        {/* Logo with subtle animation */}
        <div className="relative">
          <div className="absolute inset-0 bg-gradient-to-r from-primary-500/20 to-primary-600/20 rounded-full blur-2xl animate-pulse"></div>
          <img
            src="/cmt-logo.png"
            alt="Connect Management Logo"
            className="relative h-24 w-24 object-contain animate-scale-in"
          />
        </div>
        
        {/* App name */}
        <div className="text-center animate-fade-in-up">
          <h1 className="text-heading-lg font-display bg-gradient-to-r from-gray-900 to-gray-700 dark:from-tech-50 dark:to-tech-200 bg-clip-text text-transparent">
            Mobile App
          </h1>
          <p className="text-caption text-primary-500 dark:text-primary-400 uppercase tracking-wider font-mono mt-2">
            Connect
          </p>
        </div>

        {/* Loading indicator */}
        <div className="flex items-center space-x-2 animate-fade-in-up delay-300">
          <div className="w-2 h-2 bg-primary-500 rounded-full animate-bounce"></div>
          <div className="w-2 h-2 bg-primary-500 rounded-full animate-bounce delay-100"></div>
          <div className="w-2 h-2 bg-primary-500 rounded-full animate-bounce delay-200"></div>
        </div>
      </div>
    </div>
  )
}